import {
  Component,
  computed,
  effect,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  signal,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { assets } from "../../core/constants/assets.const";
import { KnobModule } from "primeng/knob";
import { FormsModule } from "@angular/forms";
import { CustomProgressComponent } from "../../shared/components/custom-progress/custom-progress.component";
import { BaseClass } from "../../shared/class/BaseClass";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CartService } from "../../service/cart.service";
import { ATTEMPT_STATUS } from "../../core/constants/keys.const";

@Component({
  selector: "notchmark-quiz-layout",
  imports: [
    RouterModule,
    ButtonModule,
    KnobModule,
    FormsModule,
    CustomProgressComponent,
  ],
  templateUrl: "./quiz-layout.component.html",
  styleUrl: "./quiz-layout.component.scss",
})
export class QuizLayoutComponent extends BaseClass implements OnInit, OnDestroy {
  assetsConst = assets;
  secondsValue = 54;
  attemptId = "";
  practiceSetId = "";
  attemptedCount = "";
  durationMin = 0;
  private remainingSecondsSignal = signal(0);
  private totalQuestionsSignal = signal(0);
  private answeredQuestionsSignal = signal(0);
  private cartService = inject(CartService);

  displayTime = computed(() => {
    const seconds = this.remainingSecondsSignal();
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours}h:${minutes}m:${secs}s`;
  });

// This is already in your code and works correctly
progressValue = computed(() => {
  const total = this.totalQuestionsSignal();
  const answered = this.answeredQuestionsSignal();
  return total > 0 ? Math.round((answered / total) * 100) : 0;
});


  private timerInterval: any;
  attemptCount!: string | null;
  title!: string | null;
  constructor(injector: Injector) {
    super(injector);
    effect(() => {
      const remaining = this.remainingSecondsSignal();
      if (remaining === 0) {
        this.stopCountdown();
      }
    });
  }
ngOnInit() {
  this.route.queryParams.subscribe((params) => {
    // Get necessary parameters from the route
    this.practiceSetId = params["practiceSetId"];
    this.durationMin = params["durationMin"]; // duration in minutes
    this.attemptId = params["attemptId"];
    this.attemptCount = sessionStorage.getItem('examAttemptCount');
    this.title = sessionStorage.getItem('examTitle');
    this.attemptedCount = params["attemptedCount"];
    
    // Check if there is a saved remaining time in localStorage
    const savedTime = localStorage.getItem('quizRemainingSeconds');
    if (savedTime !== null) {
      // If saved time exists, restore it to the signal
      this.remainingSecondsSignal.set(+savedTime);
    } else {
      // Otherwise, initialize with full duration in seconds
      this.remainingSecondsSignal.set(this.durationMin * 60);
    }
    
    // Start the countdown timer
    this.startCountdown();
  });
}

startCountdown() {
  this.timerInterval = setInterval(() => {
    this.remainingSecondsSignal.update((value) => {
      const newVal = value > 0 ? value - 1 : 0;
      localStorage.setItem('quizRemainingSeconds', newVal.toString());
      return newVal;
    });
  }, 1000);
}

  stopCountdown() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateAnsweredCount(count: number, total: number) {
    this.answeredQuestionsSignal.set(count);
    this.totalQuestionsSignal.set(total);
  }

  exitTest(): void {
    const requestBody = {
      attemptId: this.attemptId,
      status: ATTEMPT_STATUS.EXIT,
    };

    this.cartService
      .PauseQuestion(requestBody)
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe({
        next: () => {
          this.router.navigate(["/my-tests"]);
        },
      });
  }
  ngOnDestroy() {
    this.stopCountdown();
  }
}
